export default "__VITE_ASSET__ab82922e__"